import { Fragment } from '@wordpress/element';

const SortableTable = ({ measure, tableData }) => {
    const { p, h1, h2 } = tableData;
    return (
        <Fragment>
            <div>
                <p className="intro-text">{p}</p>
                <div className="table__header">{h1}</div>
                <div className="table__subheader">{h2}</div>
                <table
                    className="full-table ui table prc-table prc-dt-auto-init no-footer dtr-inline"
                    id="habits-table"
                >
                    <thead>
                        <tr>
                            <th>Source</th>
                            <th>Millennial</th>
                            <th>Generation X</th>
                            <th>Baby Boomer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.data.map((datum) => (
                            <tr name={datum['Source']}>
                                <td>{datum['Source']}</td>
                                <td>{datum['Millennial']}</td>
                                <td>{datum['Generation X']}</td>
                                <td>{datum['Baby Boomer']}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
};

export default SortableTable;
